__turbopack_context__.v({
  "active": "ReviewCard-module-scss-module__Due3XW__active",
  "date": "ReviewCard-module-scss-module__Due3XW__date",
  "header": "ReviewCard-module-scss-module__Due3XW__header",
  "name": "ReviewCard-module-scss-module__Due3XW__name",
  "productHref": "ReviewCard-module-scss-module__Due3XW__productHref",
  "smallCard": "ReviewCard-module-scss-module__Due3XW__smallCard",
  "text": "ReviewCard-module-scss-module__Due3XW__text",
  "wrapper": "ReviewCard-module-scss-module__Due3XW__wrapper",
});
